<template>
  <main>
    <!-- <div class="-Topbar"></div> -->
    <div class="container findpwd_style" :class="{jp: $region === 'jp', sea: $area === 'komoe-sea'}">
      <div class="findpwd_top">
        <h3 v-html="state < 3 ? $t('findpwd.findPwd') : $t('findpwd.resetPwd')"></h3>
        <hr class="green" />
        <h5 v-if="$area !== 'komoe-sea'">{{$t('findpwd.uppercasePassword')}}</h5>
      </div>
      <div v-show="state==0" class="state_box state_1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm_0" class="selectAccount" label-position="left">
          <el-form-item prop="accountType" ref="accountType">
            <el-select
              :placeholder="$t('findpwd.selectAccountType')"
              style="width: 360px"
              v-model="ruleForm.accountType"
            >
              <template v-for="(item, index) in accountTypes">
                <el-option
                  :key="index"
                  :label="item.text"
                  :value="item.id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="submit-box-bot">
            <div class="submit-btn" @click="submit_0" ga-data="1301001">
              {{$t('findpwd.next')}}
              <img src="./img/arrow_right_circle.svg" alt />
            </div>
          </div>
      </div>  
      <!-- 步驟一 -->
      <div v-show="state==1" class="state_box state_1">
        <h3>{{$t('findpwd.inputYourAccount')}}</h3>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm_1">
          <el-form-item prop="phone" ref="phone" v-if="accountType === 'phone'">
            <k-select
              :selected="selected"
              :options="codeList"
              @selectedOption="selectOption"
              class="code-area"
            ></k-select>
            <el-input
              class="phone-input"
              v-model="ruleForm.phone"
              :placeholder="$t('findpwd.insertPhone')"
              height="50px"
              ref="input1"
              @focus="resetPhone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email" ref="email" v-if="accountType === 'email'">
            <div class="form-label" v-if="$area === 'komoe-sea'">{{$t('findpwd.emailAddress')}}</div>
            <el-input
              class="email-input"
              v-model="ruleForm.email"
              :placeholder="$t('findpwd.insertEmail')"
              height="50px"
              @focus="resetEmail"
            ></el-input>
          </el-form-item>
          <el-form-item prop="imgCode" ref="imgCode">
            <div class="form-label" v-if="$area === 'komoe-sea'">{{$t('findpwd.verificationLabel')}}</div>
            <el-input
              v-model="ruleForm.imgCode"
              :placeholder="$t('findpwd.pleaseInsertGraph')"
              @focus="resetCode"
            ></el-input>
            <span class="code-tip modal-code" :class="{'imgCode': accountType === 'email'}" v-if="$region === 'komoe'" @click="getImgCode">
              <img :src="codeImg" />
            </span>
            <span class="code-tip modal-code" v-else @click="getImgCode">
              <img :src="codeImg" @error="switchCaptchaLine" />
            </span>
          </el-form-item>
          <div class="submit-box-bot">
            <div class="submit-btn" @click="submit_1" ga-data="1301001">
              {{$t('findpwd.next')}}
              <img src="./img/arrow_right_circle.svg" alt />
            </div>
          </div>
        </el-form>
      </div>

      <!-- 确认点击邮箱链接 -->
      <div v-show="state == 'confirmLink'" class="state_box">
        <div class="confirm-des">
          {{$t('findpwd.mailSentTo')}} <span class="confirm-email">{{ ruleForm.email }}</span>. <br />{{$t('findpwd.confirmClick')}}
        </div>
        <div class="submit-box-bot">
          <div class="submit-btn" @click="confirmLink">
            {{$t('findpwd.confirmation')}}
            <img src="./img/arrow_right_circle.svg" alt />
          </div>
          <div class="submit-btn ta-left" @click="submit_1" ga-data="1301001">
              <div class="s-l-txt" v-if="resendCount <= 0">
                <div class="s-b-txt">
                  {{$t('findpwd.notReceived')}}
                </div>
                <div class="s-s-txt">
                  {{$t('findpwd.sendAgain')}}
                </div>
              </div>
              <div class="s-l-txt" v-else>
                <div class="s-b-txt">
                  {{$t('findpwd.resendAfter', {resendCount: resendCount})}}
                </div>
              </div>
              <img src="./img/arrow_right_circle.svg" alt />
            </div>
        </div>
        <div class="confirm-error" v-if="showNotConfirmed">
          {{$t('findpwd.clickAgain')}}
        </div>
      </div>


      <!-- 步骤二 -->
      <div v-show="state==2" class="state_box state_2">
        <h3 v-if="accountType === 'phone'">
          {{$t('findpwd.phoneCodeSent')}}
          <span class="phone" v-html="ruleForm.phone"></span>
        </h3>
        <h3 v-if="accountType === 'email'">
          {{$t('findpwd.emailCodeSent')}}
          <span class="phone" v-html="ruleForm.email"></span>
        </h3>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm_2">
          <el-form-item prop="msgCode" ref="msgCode" v-if="accountType === 'phone'">
            <el-input
              v-model="ruleForm.msgCode"
              :placeholder="$t('findpwd.pleaseInsertCode')"
              @focus="resetMsgCode"
            ></el-input>
            <span
              class="code-tip"
              :class="{jp: $region === 'jp'}"
              v-if="msgCode_gap>0"
              v-text="$t('findpwd.resend') + msgCode_gap + 's'"
            ></span>
            <span
              class="code-tip"
              :class="{p010: $region === 'jp'}"
              v-else
              @click="getBack"
              ga-data="1301003"
            >{{$t('findpwd.resend')}}</span>
          </el-form-item>
          <el-form-item prop="emailCode" ref="emailCode" v-if="accountType === 'email'">
            <el-input
              v-model="ruleForm.emailCode"
              :placeholder="$t('findpwd.pleaseInsertCode')"
              @focus="resetEmailCode"
            ></el-input>
            <span
              class="code-tip"
              :class="{jp: $region === 'jp'}"
              v-if="msgCode_gap>0"
              v-text="$t('findpwd.resend') + msgCode_gap + 's'"
            ></span>
            <span
              class="code-tip"
              :class="{p010: $region === 'jp'}"
              v-else
              @click="getBack"
              ga-data="1301003"
            >{{$t('findpwd.resend')}}</span>
          </el-form-item>

          <div class="submit-box-bot">
            <div class="submit-btn" @click="submit_2" ga-data="1301002">
              {{$t('findpwd.next')}}
              <img src="./img/arrow_right_circle.svg" alt />
            </div>
          </div>
        </el-form>
      </div>

      <!-- 步驟三 -->
      <div v-show="state==3" class="state_box state_3">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm_3">
          <el-form-item prop="password" ref="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              :placeholder="$t('findpwd.insertNewPwd')"
            ></el-input>
          </el-form-item>

          <el-form-item prop="v_password" ref="v_password">
            <el-input
              type="password"
              v-model="ruleForm.v_password"
              :placeholder="$t('findpwd.reinsertPwd')"
            ></el-input>
          </el-form-item>

          <div class="submit-box-bot">
            <div class="submit-btn" @click="submit_3" ga-data="1301004">
              {{$t('findpwd.next')}}
              <img src="./img/arrow_right_circle.svg" alt />
            </div>
          </div>
        </el-form>
      </div>

      <!-- 步驟四 -->
      <div v-show="state==4" class="state_box state_4">
        <h3>{{$t('findpwd.resetComplete')}}</h3>
        <h5>{{$t('findpwd.pleaseRelogin')}}</h5>
        <p v-if="accountType === 'phone'">
          <router-link :to="loginUrl" class="goLogin" ga-data="1302001">{{$t('findpwd.relogin')}}</router-link>
        </p>
        <p v-if="accountType === 'email'">
          <router-link :to="loginUrl" class="goLogin">{{$t('findpwd.relogin')}}</router-link>
        </p>
      </div>
    </div>
    <!-- <div class="-Footer"></div> -->
    <error-modal :msg="errorMsg" @closeModal="closeErrorModal" v-if="errorFlag"></error-modal>
  </main>
</template>

<script>
import Vue from "vue";
import { Input, FormItem, Form } from "element-ui";
import emailValidateRules from '../js/emailValidate'
import utils from "@/utils";
const { getParams } = utils;

import JSEncrypt from "jsencrypt";

import kSelect from "@/component/select/select.vue";
import ErrorModal from "@/component/modal/error.vue";
Vue.use(Input);
Vue.use(FormItem);
Vue.use(Form);
require("../../elementUI/elementUI");
export default {
  name: "findpwd",
  components: {
    kSelect,
    ErrorModal
  },
  data() {
    var vm = this;
    // 校驗手機號
    var validPhone = (rule, value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('findpwd.insertPhone')));
      } else {
        if (!value.match("^[0-9]{5,12}$")) {
          return callback(vm.$t('findpwd.insertCorrectPhone'));
        } else if (this.phone_state != true) {
          return callback(new Error(this.phone_state));
        }
        return callback();
      }
    };
    var validEmail = (rule, value, callback) => {
      const emailPattern = emailValidateRules[this.$area]
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('findpwd.insertEmail')));
      } else {
        if (!emailPattern.test(value)) {
          return callback(vm.$t('findpwd.insertCorrectEmail'));
        } else if (this.email_state != true) {
          return callback(new Error(this.email_state));
        }
        return callback();
      }
    };
    // 校驗圖形驗證碼
    var validImgCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(vm.$t('findpwd.pleaseInsertGraph')));
      } else {
        if (!this.imgCode_state) {
          return callback(new Error(vm.$t('findpwd.wrongGraphCode')));
        }
        return callback();
      }
    };
    // 校驗短信驗證碼
    var validMsgCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(vm.$t('findpwd.insertSmsCode')));
      } else {
        if (this.msgCode_state != true) {
          return callback(new Error(this.msgCode_state));
        }
        return callback();
      }
    };
    // 校驗短信驗證碼
    var validEmailCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(vm.$t('findpwd.insertEmailCode')));
      } else {
        if (this.emailCode_state != true) {
          return callback(new Error(this.emailCode_state));
        }
        return callback();
      }
    };
    // 校驗密碼
    var validPass = (rule, value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('findpwd.inputNewPwd')));
      } else {
        if (value.length < 6) {
          return callback(new Error(vm.$t('findpwd.pwdRule1')));
        } else if (value.length > 16) {
          return callback(new Error(vm.$t('findpwd.pwdRule2')));
        } else {
          return callback();
        }
      }
    };
    // 校驗重複密碼
    var validPassword = (rule, value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('findpwd.pleaseRepasswordLabel')));
      } else {
        if (value !== this.ruleForm.password) {
          this.submitReady_3 = false;
          return callback(new Error(vm.$t('findpwd.differentPassword')));
        } else {
          return callback();
        }
      }
    };

    return {
      lineIndex: 1,
      accountType: this.$region === "jp" || (this.$region === "komoe" && this.$area === 'komoe-sea') ? "email" : "",
      state: this.$region === "komoe" && this.$area === 'komoe' ? 0 : 1,
      // 找回密码地址
      loginUrl: getParams('type') === 'both' ? '/login?type=both' : '/login',
      msgCode_gap: 0,
      selected: {
        val: "",
        id: ""
      },
      timer: null,
      codeList: [],
      codeImg: "",
      imgToken: "",
      ruleForm: {
        accountType: "",
        phone: "",
        email: "",
        imgCode: "",
        emailCode: "",
        msgCode: "",
        password: "",
        v_password: ""
      },
      rules: {
        accountType: [
          { required: true, message: this.$t('findpwd.selectAccountType'), trigger: 'change' },
        ],
        phone: [
          {
            validator: validPhone,
            trigger: "blur"
          }
        ],
        email: [
          {
            validator: validEmail,
            trigger: "blur"
          }
        ],
        imgCode: [
          {
            validator: validImgCode,
            trigger: "blur"
          }
        ],
        msgCode: [
          {
            validator: validMsgCode,
            trigger: "blur"
          }
        ],
        emailCode: [
          {
            validator: validEmailCode,
            trigger: "blur"
          }
        ],
        password: [
          {
            validator: validPass,
            trigger: "blur"
          }
        ],
        v_password: [
          {
            validator: validPassword,
            trigger: "blur"
          }
        ]
      },
      phone_state: true,
      email_state: true,
      // 图形验证码状态
      imgCode_state: true,
      msgCode_state: true,
      emailCode_state: true,
      emailTicket: '',
      resendCount: 0,
      accountTypes: [
        {
          id: 'phone',
          text: '手機號碼',
        },
        {
          id: 'email',
          text: '郵箱地址',
        }
      ],
      showNotConfirmed: false,
      errorMsg: '',
      errorFlag: false
    };
  },
  methods: {
    // 獲取國家列表
    getCodeList() {
      this.$apis.common.getCountryList().then(
        res => {
          this.codeList = res.data.data.map(item => {
            return {
              id: item.id,
              val: "+" + item.country_id
            };
          });

          // 初始化賦值
          this.selected.val = this.codeList[0].val;
          this.selected.id = this.codeList[0].id;
        }
      ).catch(() => {
        this.errorMsg =this.$t('findpwd.badNetwork');
        this.errorFlag = true;
      });
    },
    switchCaptchaLine() {
      this.getCode("switch");
    },

    getCode(tag) {
      if (tag === "switch") {
        if (this.lineIndex < 20) {
          ++this.lineIndex;
        } else {
          return;
        }
      }
      if (this.$region === "jp") {
        this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else {
        const captchaImgDomain = this.accountType === 'email' ? 'captchaImgDomainGlobal' : 'captchaImgDomain'
        const prefix = this.accountType === 'email' ? '/web' : ''
        this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig[captchaImgDomain]}${prefix}/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      }
    },

    getCodeFromApi() {
      this.$apis.common.getCaptchaCode(5, true).then(res => {
        if (res.data.code === 0) {
          var imgUrl = res.data.data.img_url.split('//')
          this.codeImg = window.location.protocol + '//' + imgUrl[imgUrl.length - 1]
          this.imgToken = res.data.data.img_token
        }
      })
    },

    // 獲取圖形驗證碼
    getImgCode() {
      if (this.$region === 'komoe' && this.accountType === 'email') {
        this.getCodeFromApi()
      } else {
        this.getCode()
      }
    },

    // 重置图形验证码状态
    resetPhone() {
      this.phone_state = true;
    },

    resetEmail() {
      this.email_state = true;
    },

    // 重置图形验证码状态
    resetCode() {
      this.imgCode_state = true;
    },

    // 重置短信验证码状态
    resetMsgCode() {
      this.msgCode_state = true;
    },

    resetEmailCode() {
      this.emailCode_state = true;
    },

    // 重新發送驗證碼
    getBack() {
      if (this.msgCode_gap > 0) return;
      this.state = 1;
      this.getImgCode();
      this.msgCode_state = true;
      this.emailCode_state = true;
    },
    // 发送短信验证码
    sendSmsCode() {
      // 提交图形验证码,发短信验证码
      this.$apis.findpwd
        .getSmsGenericSend(
          this.selected.id,
          this.ruleForm.phone + "",
          1,
          this.ruleForm.imgCode
        )
        .then(
          res => {
            if (res.data.code == 0) {
              this.state = 2;
              this.msgCode_gap = 60;
              this.imgCode_state = true;
              this.phone_state = true;
              this.startInterval();
            } else if (res.data.code == -105) {
              this.imgCode_state = false;
              this.getImgCode();
              if (this.state == 1) {
                this.$refs.ruleForm_1.validateField("imgCode");
              }
            } else {
              this.phone_state = this.showErrorMessage(res.data, this.$t('findpwd.badRequest'))

              if (this.state == 1) {
                this.$refs.ruleForm_1.validateField("phone");
              }
            }
          }
        ).catch(() => {
          this.errorMsg =this.$t('findpwd.badNetwork');
          this.errorFlag = true;
        });
    },
    sendEmailCode() {
      // 提交图形验证码,发短信验证码
      this.$apis.findpwd
        .sendEmailCode(this.ruleForm.email, 1, this.ruleForm.imgCode)
        .then(
          res => {
            if (res.data.code == 0) {
              this.state = 2;
              this.msgCode_gap = 60;
              this.imgCode_state = true;
              this.email_state = true;
              this.startInterval();
            } else if (res.data.code == -105) {
              this.imgCode_state = false;
              this.getImgCode();
              if (this.state == 1) {
                this.$refs.ruleForm_1.validateField("imgCode");
              }
            } else {
              this.email_state = this.showErrorMessage(res.data, this.$t('findpwd.badRequest'));

              if (this.state == 1) {
                this.$refs.ruleForm_1.validateField("email");
              }
            }
          }
        ).catch(() => {
          this.errorMsg =this.$t('findpwd.badNetwork');
          this.errorFlag = true;
        });
    },
    // 1分钟倒计时
    countDownResend() {
      let counter = null
      const countDown = () => {
        if (this.resendCount > 0) {
          this.resendCount--
          counter = setTimeout(() => {
            countDown()
          }, 1000)
        } else {
          clearTimeout(counter)
        }
      }
      this.resendCount = 60
      countDown()
    },

    sendEmailLink(token, code) {
      if (this.resendCount > 0) {
        return
      }
      this.$apis.common.sendEmailLink({
        "email": this.ruleForm.email,
        "email_type": 1,
        "captcha": code,
        "img_token": token,
        "distribution_region": this.$siteConfig.distribution_region,
        "changeBaseUrl": true
      }).then(res => {
        if (res.data.code == 0) {
          this.state = 'confirmLink'
          this.emailTicket = res.data.data.email_ticket
          this.countDownResend()
          this.showNotConfirmed = false
        } else {
          this.handleErrorCode(res.data);
          // 非重发邮件时才重新获取验证码
          if (this.state !== 'confirmLink') {
            this.getImgCode()
          }
        }
      })
    },
    // 检查邮箱链接是否点击
    confirmLink() {
      this.$apis.findpwd.checkEmailLink(this.emailTicket, this.ruleForm.email, 1, true).then((res) => {
        if (res.data.code == 0) {
          this.state = 3
          this.showNotConfirmed = false
        } else {
          if (res.data.code === 510012) {
            this.showNotConfirmed = true
          }
          this.handleErrorCode(res.data);
        }
      });
    },
 
    // 选择修改账号类型-小萌
    submit_0() {
      this.$refs.ruleForm_0.validate().then(() => {
        this.accountType = this.ruleForm.accountType
        if (this.accountType === "phone") {
          this.getCodeList();
          this.getImgCode();  
        } else {
          this.getImgCode();
        }
        this.state = 1;
      })
    },

    // 步驟一 提交
    submit_1() {
      this.$refs.ruleForm_1.validate().then(() => {
        // 判断是手机号，邮箱，还是两者都可以
        if (this.accountType === "phone") { // 手机号
          this.sendSmsCode();
        } else if (this.accountType === "email") { // 邮箱
          if (this.$region === 'komoe') {
            // 东南亚通知发送修改密码邮件
            this.sendEmailLink(this.imgToken, this.ruleForm.imgCode)
          } else {
            // 日本通知发送修改密码邮件
            this.sendEmailCode();
          }
        }
      });
    },

    // 提交短信驗證碼
    checkSmsCode() {
      this.$apis.findpwd
        .getSmsGenericCheck(
          this.selected.id,
          String(this.ruleForm.phone),
          this.ruleForm.msgCode,
          1
        )
        .then(
          res => {
            if (res.data.code == 0) {
              this.state = 3;
              clearInterval(this.timer);
              this.msgCode_state = true;
            } else {
              this.msgCode_state = this.showErrorMessage(res.data);
              this.$refs.ruleForm_2.validateField("msgCode");
            }
          }
        ).catch(() => {
          this.errorMsg =this.$t('findpwd.badNetwork');
          this.errorFlag = true;
        });
    },
    checkEmailCode() {
      this.$apis.findpwd
        .checkEmailCode(this.ruleForm.email, this.ruleForm.emailCode, true)
        .then(
          res => {
            if (res.data.code == 0) {
              this.state = 3;
              clearInterval(this.timer);
              this.emailCode_state = true;
            } else {
              this.emailCode_state = this.showErrorMessage(res.data);
              this.$refs.ruleForm_2.validateField("emailCode");
            }
          }
        ).catch(() => {
          this.errorMsg =this.$t('findpwd.badNetwork');
          this.errorFlag = true;
        });
    },
    // 第二步提交
    submit_2() {
      this.msgCode_state = true;
      this.emailCode_state = true;
      if (this.accountType === "phone") {
        this.$refs.ruleForm_2.validate().then(() => {
          this.checkSmsCode();
        });
      } else if (this.accountType === "email") {
        this.$refs.ruleForm_2.validate().then(() => {
          this.checkEmailCode();
        });
      }
    },

    resetPhonePwd() {
      this.$apis.findpwd
        .resetPwd(
          this.selected.id,
          String(this.ruleForm.phone),
          this.ruleForm.msgCode,
          this.ruleForm.password,
          this.ruleForm.v_password
        )
        .then(
          res => {
            if (res.data.code == 0) {
              this.state = 4;
            } else {
              // 回到上一步骤
              this.state = 2;
              // 清空倒计时
              this.msgCode_gap = 0;
              clearInterval(this.timer);
              this.msgCode_state = this.showErrorMessage(res.data);
              this.$refs.ruleForm_2.validateField("msgCode");
            }
          }
        ).catch(() => {
          this.errorMsg =this.$t('findpwd.badNetwork');
          this.errorFlag = true;
        });
    },

    resetNewEmailPwd() {
      var password = this.ruleForm.password;
      var resetPwd = pwd => {
        this.$apis.findpwd
          .resetNewEmailPwd(this.emailTicket, pwd, pwd, true)
          .then(
            res => {
              if (res.data.code == 0) {
                this.state = 4;
              } else {
                // 回到上一步骤
                this.state = 'confirmLink';
                this.handleErrorCode(res.data)
              }
            }
          ).catch(() => {
             this.errorMsg =this.$t('findpwd.badNetwork');
             this.errorFlag = true;
          });
      };

      var handleEncrypt = (res, cb) => {
        var jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(res.data.data.rsa_key);
        var output = jsencrypt.encrypt(res.data.data.hash + password);
        var code = res.data.code;
        if (code === 0) {
          // 获取publickey后，执行loginFG
          cb(output);
        } else {
          this.handleErrorCode(res.data)
        }
      };
      this.$apis.findpwd.getResetPublicKey(true).then(res => {
        handleEncrypt(res, resetPwd);
      });
    },

    resetEmailPwd() {
      var password = this.ruleForm.password;
      var resetPwd = pwd => {
        this.$apis.findpwd
          .resetEmailPwd(this.ruleForm.email, this.ruleForm.emailCode, pwd, pwd)
          .then(
            res => {
              if (res.data.code == 0) {
                this.state = 4;
              } else {
                // 回到上一步骤
                this.state = 2;
                // 清空倒计时
                this.msgCode_gap = 0;
                clearInterval(this.timer);
                this.emailCode_state = this.showErrorMessage(res.data);
                this.$refs.ruleForm_2.validateField("emailCode");
              }
            }
          ).catch(() => {
             this.errorMsg =this.$t('findpwd.badNetwork');
             this.errorFlag = true;
          });
      };
      var handleEncrypt = (res, cb) => {
        var jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(res.data.data.rsa_key);
        var output = jsencrypt.encrypt(res.data.data.hash + password);
        var code = res.data.code;
        if (code === 0) {
          // 获取publickey后，执行loginFG
          cb(output);
        } else {
          this.handleErrorCode(res.data)
        }
      };
      this.$apis.findpwd.getResetPublicKey(true).then(res => {
        handleEncrypt(res, resetPwd);
      });
    },

    // 步驟三 提交
    submit_3() {
      this.$refs.ruleForm_3.validate().then(() => {
        if (this.accountType === "phone") { // 短信重置密码
          this.resetPhonePwd();
        } else if (this.accountType === "email") { // 邮箱重置密码  
          if (this.$region === 'komoe') { // 东南亚邮箱重置密码
            this.resetNewEmailPwd();
          } else { // 日本邮箱重置密码
            this.resetEmailPwd();
          }
        }
      });
    },

    selectOption(item) {
      this.selected = item;
    },
    closeModal() {
      this.showCodeImg = false;
    },
    // 发送短信验证码倒计时
    startInterval() {
      this.timer = setInterval(() => {
        if (this.msgCode_gap > 0) {
          this.msgCode_gap = this.msgCode_gap - 1;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    showErrorMessage(data, message = ''){
       if (this.$area !== 'komoe-sea') {
        return data.message
      } else { 
        return this.getResCode(data.code) || message
      }
    },
    handleErrorCode(data) {
      if (data.code == -101) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href
          }
        });
        return false;
      }

      if (this.$area !== 'komoe-sea') {
        this.errorMsg = data.message
      } else {
        const popText = this.getResCode(data.code);
        this.errorMsg = popText ? popText : this.$t('account.serverError');
      }

      this.errorFlag = true;
    },
    // 关闭错误信息弹窗
    closeErrorModal() {
      this.errorFlag = false;
    },
  },
  mounted() {
    if (this.$area !== 'komoe') {
      this.getImgCode();
    }
  }
};
</script>

<style lang="scss">
@import "../../elementUI/elementUI.scss";
</style>
<style lang="scss" scoped>
@import "@/views/scss/common.scss";

a {
  text-decoration: none;
}
main {
  min-width: 1300px;
}

.container {
  width: 1170px;
  margin: 0 auto;
  text-align: center;
  min-height: calc(100vh - 242px);
  .confirm-des {
    margin-bottom: 42px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
  }
  .confirm-email {
    color: #2da2d4;
  }
  .confirm-error {
    margin-top: 20px;
    color: #f56c6c;
    font-size: 12px;
    // text-align: center;
  }
  &.en {
    .findpwd_top h3 {
      font-size: 20px;
    }
    .state_3 {
      .el-form {
        float: none;
      }
    }
    .state_1 {
      width: 540px;
      @extend %clearfix;
      h3 {
        margin-left: -60px;
        margin-bottom: 40px;
      }
      .submit-btn {
        margin-left: -90px;
      }
    }
    .el-form {
      float: right;
      width: 440px;
    }
  }
  .findpwd_top {
    padding: 40px 0;
    border-bottom: 1px solid #cccccc;
    h3 {
      font-size: 32px;
      color: #444444;
    }
    hr.green {
      width: 24px;
      height: 4px;
      background: #2da2d4;
      border-radius: 2px;
      margin: 10px 0;
      border: 0;
      margin: 0 auto;
    }
    h5 {
      font-size: 14px;
      color: #cccccc;
      font-weight: normal;
    }
  }
  .state_box {
    width: 400px;
    margin: 0 auto;
    padding-top: 40px;
    h3 {
      font-size: 14px;
      color: #444444;
      font-weight: normal;
      margin: 0px 0 20px 0;
      span.phone {
        color: #2da2d4;
      }
    }
    .form-label {
      position: absolute;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
      width: 186px;
      height: 100%;
      top: 0;
      right: 100%;
      font-weight: bold;
    }
  }
  .state_4 {
    h3 {
      font-size: 24px;
      color: #333333;
      margin-bottom: 20px;
    }
    h5 {
      font-size: 14px;
      color: #999999;
      margin-bottom: 40px;
    }
    a {
      display: inline-block;
      width: 170px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #ffffff;
      border-radius: 20px;
      background: #2da2d4;
    }
  }
} // 表單類樣式

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
.findpwd_style {
  &.sea {
    .submit-box-bot .submit-btn {
      height: 48px;
      line-height: 48px;
      border-radius: 24px;
      &.lh24 {
        line-height: 24px;
      }
      &.ta-left {
        display: flex;
        justify-content: center;
        margin-left: 52px;
        text-align: left;
        line-height: 18px;
        text-indent: 10px;
      }
    }
    .s-l-txt {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .s-s-txt {
      font-size: 12px;
    }
    .code-tip {
      &.modal-code {
        border-width: 1px;
        img {
          margin-top: 0;
          height: 100%;
        }
      }
    }
    .el-form .el-form-item .el-form-item__content .el-input__inner {
      border-width: 1px;
    }
  }
  &.jp {
    .el-form .el-form-item .el-form-item__content .el-input__inner {
      border-width: 1px;
    }
    .el-form .el-form-item .el-form-item__content .code-tip.modal-code {
      border-width: 1px;
    }
  }
  .el-select-dropdown__item.selected {
    color: #2da2d4;
  }
  .code-tip {
    position: absolute;
    top: 10px;
    right: 0;
    width: 112px;
    text-align: center;
    color: #2da2d4;
    line-height: 30px;
    border-left: 1px solid #eee;
    cursor: pointer;
    &.p010 {
      padding: 0 10px;
    }
    &.jp {
      width: 168px;
    }
    &.modal-code {
      top: 6px;
      right: 6px;
      height: 34px;
      border: 2px solid rgba(0, 0, 0, 0.2);
      border-radius: 20px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        margin-top: 4px;
      }
    }
    &.imgCode {
      img {
        margin-top: -11px;
      }
    }
  }
  .el-form {
    .el-form-item {
      position: relative;
      margin-bottom: 40px;
      .el-form-item__content {
        line-height: 50px;
        .phone-input .el-input__inner {
          padding-left: 95px;
        }
        .code-area {
          position: absolute;
          top: 10px;
          left: 0;
          z-index: 2;
          width: 85px;
          height: 30px;
          line-height: 30px;
          border-right: 1px solid #eee;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            border: none;
            color: #2da2d4;
          }
        }
        .el-input__inner {
          height: 50px;
          line-height: 50px;
          text-indent: 5px;
          border-width: 2px;
          border-radius: 25px;
          &:focus {
            border-color: #2da2d4;
          }
        }
        
      }
    }
  }
  .submit-box-bot {
    display: flex;
    justify-content: center;
    .submit-btn {
      width: 170px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #2da2d4;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 12px;
        margin-left: 10px;
      }
      &:hover {
        color: #2da2d4;
      }
    }
    .submit-btn:first-child {
      margin-right: 20px;
    }
  }
}
</style>